import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AffiliateCTA = () => {
  const navigate = useNavigate();

  return (
    <section className="py-12 sm:py-14 md:py-16 lg:py-20 px-4 sm:px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="bg-gradient-to-r from-purple-600 to-purple-800 text-white rounded-xl sm:rounded-2xl p-5 sm:p-6 md:p-7 lg:p-8 text-center">
          <Icon name="Rocket" size={36} className="sm:hidden mx-auto mb-3" />
          <Icon name="Rocket" size={42} className="hidden sm:block md:hidden mx-auto mb-3" />
          <Icon name="Rocket" size={48} className="hidden md:block mx-auto mb-4" />
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-3.5 md:mb-4 px-2">
            Comienza a Ganar Hoy Mismo
          </h3>
          <p className="text-sm sm:text-base md:text-lg opacity-90 mb-4 sm:mb-5 md:mb-6 max-w-2xl mx-auto px-2">
            Obtén tu enlace de referido único al registrarte y comparte con tu red. Cada registro exitoso te acerca a tus metas financieras.
          </p>
          <Button
            variant="default"
            size="lg"
            iconName="ArrowRight"
            iconPosition="right"
            onClick={() => navigate('/user-registration')}
            className="bg-white text-purple-700 hover:bg-white/90 w-full sm:w-auto min-w-[200px] sm:min-w-[220px]"
          >
            Únete al Programa
          </Button>
        </div>
      </div>
    </section>
  );
};

export default AffiliateCTA;